import { render } from "./App.vue?vue&type=template&id=3ae5b4b6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./assets/css/index.css?vue&type=style&index=0&lang=css"
import "./App.vue?vue&type=style&index=1&id=3ae5b4b6&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__